import { useOrg } from "contexts/orgContext";
import type { OrgFeatures } from "models";

export function useFeatureFlag(flag: keyof OrgFeatures): boolean {
  const { currentOrg } = useOrg();
  return currentOrg?.features?.[flag] === true;
}
